module.exports = "<div class=\"row\" id=\"toggle\">\n\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t<div class=\"switch\" ng-click=\"toggleCtrl.toggle()\">\n\t\t\t<input type=\"checkbox\"\n\t\t\t       ng-model=\"toggleCtrl.model\"\n\t\t\t       ng-false-value=\"{{!!toggleCtrl.invert}}\"\n\t\t\t       ng-true-value=\"{{!toggleCtrl.invert}}\"\n\t\t\t       class=\"toggle toggle-round\">\n\t\t\t<label></label>\n\t\t</div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toggle/template.html
// module id = 1351
// module chunks = 0